import moment from 'moment-timezone'
import { TIME_ZONE } from 'const/common'

/**
 * 获取期权的过期时间字符串。
 * 此处假设传入字符只存在 20181001 1538323200000 1538323200 三种形式
 * @param {number} expiry - 过期时间
 * @returns {string}
 */
export default function getOptionExpiryString(expiry) {
  const len = String(expiry.length)

  if (len === 8 || len === 14) return expiry.slice(0, 8)
  if (len === 10) expiry = expiry * 1000

  return moment.tz(expiry, TIME_ZONE.US).format('YYYYMMDD')
}
